import { render } from "./action-buttons.vue?vue&type=template&id=83d03c72&scoped=true"
import script from "./action-buttons.vue?vue&type=script&lang=js"
export * from "./action-buttons.vue?vue&type=script&lang=js"

import "./action-buttons.vue?vue&type=style&index=0&id=83d03c72&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d03c72"]])

export default __exports__